export default "__VITE_ASSET__tlDTb$Nf__"